export const PERSON_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type PersonShowTab = (typeof PERSON_SHOW_TABS)[number];

export const PERSON_DEFAULT_TAB: PersonShowTab = 'general';
